"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3041],{

/***/ 9101:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D": function() { return /* binding */ ActivityLog; }
});

// UNUSED EXPORTS: formatter

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/design-system/Button.tsx
var Button = __webpack_require__(968);
// EXTERNAL MODULE: ./src/design-system/Flex.ts
var Flex = __webpack_require__(7449);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(7379);
// EXTERNAL MODULE: ./src/design-system/Text.ts
var Text = __webpack_require__(2419);
;// CONCATENATED MODULE: ./src/design-system/Measurement.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        '\n  white-space: nowrap;\n\n  &:not(:last-child):after {\n    content: "\\A";\n    white-space: pre-wrap;\n  }\n\n  @media (min-width: 768px) {\n    &:not(:last-child):after {\n      content: " / ";\n      font-weight: bolder;\n      font-size: 3rem;\n      color: var(--lightBlue);\n    }\n  }\n'
    ], [
        '\n  white-space: nowrap;\n\n  &:not(:last-child):after {\n    content: "\\\\A";\n    white-space: pre-wrap;\n  }\n\n  @media (min-width: 768px) {\n    &:not(:last-child):after {\n      content: " / ";\n      font-weight: bolder;\n      font-size: 3rem;\n      color: var(--lightBlue);\n    }\n  }\n'
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: inline-block;\n  min-width: 6ch;\n  text-align: left;\n\n  @media (min-width: 768px) {\n    display: inline;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  && {\n    font-variant-numeric: oldstyle-nums;\n    font-size: 2rem;\n\n    @media (min-width: 768px) {\n      font-size: 3rem;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var BaseEntry = (0,styled_components_browser_esm/* default */.ZP)(Text/* Text */.x).withConfig({
    componentId: "sc-52565a95-0"
})(_templateObject());
var BaseUnit = (0,styled_components_browser_esm/* default */.ZP)(Text/* Text */.x).withConfig({
    componentId: "sc-52565a95-1"
})(_templateObject1());
var BaseValue = (0,styled_components_browser_esm/* default */.ZP)(Text/* Text */.x).withConfig({
    componentId: "sc-52565a95-2"
})(_templateObject2());
var Unit = function(param) {
    var unit = param.unit, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseUnit, {
        as: "span",
        $fontWeight: 300,
        className: className,
        children: unit
    });
};
var Value = function(param) {
    var value = param.value, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseValue, {
        as: "span",
        $fontWeight: 300,
        className: className,
        children: value !== null && value !== void 0 ? value : "-"
    });
};
var defaultRenderAs = "span";
var Measurement = function(param) {
    var value = param.value, unit = param.unit, _renderAs = param.renderAs, renderAs = _renderAs === void 0 ? defaultRenderAs : _renderAs;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseEntry, {
        as: renderAs,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Value, {
                value: value
            }),
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Unit, {
                unit: unit
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@styled-system/space/dist/index.esm.js + 1 modules
var index_esm = __webpack_require__(4460);
;// CONCATENATED MODULE: ./src/design-system/Table.tsx
function Table_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Table_templateObject() {
    var data = Table_taggedTemplateLiteral([
        "\n  overflow: visible;\n\n  ",
        ";\n\n  @media (min-width: 768px) {\n    ",
        ";\n  }\n\n  &:empty:first-child,\n  &:empty:last-child {\n    ",
        ";\n  }\n"
    ]);
    Table_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Table_templateObject1() {
    var data = Table_taggedTemplateLiteral([
        "\n  ",
        ";\n  width: 100%;\n  border-collapse: collapse;\n  border-spacing: 0;\n  empty-cells: show;\n"
    ]);
    Table_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Table_templateObject2() {
    var data = Table_taggedTemplateLiteral([
        "\n  border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n\n  &:last-child {\n    border-bottom: none;\n  }\n"
    ]);
    Table_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = Table_taggedTemplateLiteral([
        "\n  text-align: center;\n\n  ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = Table_taggedTemplateLiteral([
        "\n  text-align: right;\n  vertical-align: center;\n\n  ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var cellMixin = (0,styled_components_browser_esm/* css */.iv)(Table_templateObject(), (0,index_esm/* space */.Dh)({
    p: "0.75rem 0.375rem 0.75rem 0"
}), (0,index_esm/* space */.Dh)({
    p: "1.5rem 0.75rem 1.5rem 0"
}), (0,index_esm/* space */.Dh)({
    p: "1.5rem 0.75rem"
}));
var Table = styled_components_browser_esm/* default.table.withConfig */.ZP.table.withConfig({
    componentId: "sc-a72c2be8-0"
})(Table_templateObject1(), index_esm/* space */.Dh);
var Tr = styled_components_browser_esm/* default.tr.withConfig */.ZP.tr.withConfig({
    componentId: "sc-a72c2be8-1"
})(Table_templateObject2());
var Th = styled_components_browser_esm/* default.th.withConfig */.ZP.th.withConfig({
    componentId: "sc-a72c2be8-2"
})(_templateObject3(), cellMixin);
var Td = styled_components_browser_esm/* default.td.withConfig */.ZP.td.withConfig({
    componentId: "sc-a72c2be8-3"
})(_templateObject4(), cellMixin);

// EXTERNAL MODULE: ./src/functional.ts
var functional = __webpack_require__(1588);
// EXTERNAL MODULE: ./src/helpers.ts
var helpers = __webpack_require__(9238);
// EXTERNAL MODULE: ./src/hooks/useFitbit.ts
var useFitbit = __webpack_require__(8125);
// EXTERNAL MODULE: ./src/hooks/useLastNonNullableValue.ts
var useLastNonNullableValue = __webpack_require__(5673);
// EXTERNAL MODULE: ./src/hooks/useLoader.ts
var useLoader = __webpack_require__(4785);
// EXTERNAL MODULE: ./src/design-system/Stale.ts
var Stale = __webpack_require__(4087);
;// CONCATENATED MODULE: ./src/components/Fitbit/ActivityLog.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}













var formatter = new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "numeric"
});
var isBaseActivity = function(activity) {
    switch(activity.activityName){
        case "Walk":
        case "Sport":
        case "Run":
        case "Aerobic Workout":
            return true;
        default:
            return false;
    }
};
var isSwimming = function(act) {
    return act.activityName === "Swim";
};
var Body = function(param) {
    var activity = param.activity;
    if (isSwimming(activity)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Measurement, {
                    value: activity.distance,
                    unit: "km"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Measurement, {
                    value: (0,functional/* exists */.Gg)(activity.pace) ? (activity.pace / 60).toFixed(1) : "-",
                    unit: "min/km"
                })
            ]
        });
    }
    if (isBaseActivity(activity)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Measurement, {
                    value: activity.steps,
                    unit: "steps"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Measurement, {
                    value: activity.averageHeartRate,
                    unit: "bpm"
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Measurement, {
        value: activity.averageHeartRate,
        unit: "bpm"
    });
};
var beforeDateQueue = function(initial) {
    var set = new Set(initial);
    var arr = [
        initial
    ];
    return {
        add: function(date) {
            if (set.has(date)) {
                return;
            }
            set.add(date);
            arr.push(date);
        },
        get: function(index) {
            return arr[index];
        }
    };
};
var useDateQueue = function(seed, onChange) {
    var ref = (0,react.useState)(0), cursor = ref[0], setCursor = ref[1];
    var queue = (0,react.useRef)(beforeDateQueue((0,helpers/* isoStringWithoutMs */.Y1)(seed)));
    var currentDate = queue.current.get(cursor);
    var prevCurrentDate = (0,react.useRef)(currentDate);
    var prevAction = function() {
        setCursor(function(prev) {
            return prev === 0 ? prev : prev - 1;
        });
    };
    var nextAction = function(next) {
        queue.current.add(next);
        setCursor(function(prev) {
            return prev + 1;
        });
    };
    (0,react.useEffect)(function() {
        if (prevCurrentDate.current !== currentDate) {
            onChange === null || onChange === void 0 ? void 0 : onChange(currentDate);
        }
        prevCurrentDate.current = currentDate;
    }, [
        currentDate,
        onChange
    ]);
    return [
        currentDate,
        prevAction,
        nextAction
    ];
};
var noop = function() {
    return void 0;
};
var ActivityLog = function(param) {
    var initial = param.initial, _onDateChange = param.onDateChange, onDateChange = _onDateChange === void 0 ? noop : _onDateChange;
    var ref = (0,functional/* head */.YM)(initial), initialStartTime = ref.startTime;
    var ref1 = _slicedToArray(useDateQueue(initialStartTime, onDateChange), 3), currentDate = ref1[0], prevAction = ref1[1], nextAction = ref1[2];
    var ref2 = (0,useFitbit/* useFitbitActivityLog */.HH)(currentDate, initial), data = ref2.data, error = ref2.error;
    var ref3;
    var prev = (ref3 = (0,useLastNonNullableValue/* useLastNonNullableValue */.C)(data)) !== null && ref3 !== void 0 ? ref3 : [];
    var activityLog = data !== null && data !== void 0 ? data : prev;
    var stale = !error && !data;
    (0,useLoader/* useLoader */.U)(data, error);
    var ref4 = _slicedToArray(activityLog.slice(-1), 1), last = ref4[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stale/* Stale */._, {
                $stale: stale,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table, {
                    my: 3,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tr, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Th, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Th, {
                                        colSpan: 2,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                            $textAlign: "left",
                                            $fontSize: "2rem",
                                            $fontWeight: 100,
                                            children: "Activities"
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                            children: activityLog.map(function(activity) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tr, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Td, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Td, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                    $textAlign: "left",
                                                    $fontSize: "2rem",
                                                    $fontWeight: 300,
                                                    children: activity.activityName
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                    $textAlign: "left",
                                                    $fontWeight: 300,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                        as: "time",
                                                        dateTime: activity.startTime,
                                                        $fontWeight: 300,
                                                        children: formatter.format(new Date(activity.startTime))
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Td, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Measurement, {
                                                    value: (activity.activeDuration / (60 * 1000)).toFixed(1),
                                                    unit: "min"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Measurement, {
                                                    value: activity.calories,
                                                    unit: "Cals"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Body, {
                                                    activity: activity
                                                })
                                            ]
                                        })
                                    ]
                                }, activity.logId);
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                justifyContent: "space-around",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        variant: "primary",
                        disabled: currentDate === (0,helpers/* isoStringWithoutMs */.Y1)(initialStartTime),
                        onClick: prevAction,
                        children: "Back"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        disabled: stale,
                        variant: "primary",
                        onClick: function() {
                            return nextAction((0,helpers/* isoStringWithoutMs */.Y1)(last === null || last === void 0 ? void 0 : last.startTime));
                        },
                        children: "More"
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 968:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ Button; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7379);
/* harmony import */ var _styled_system_space__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4460);
/* harmony import */ var design_system_Global_theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7719);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  ",
        ";\n  font-size: ",
        ";\n  font-weight: 400;\n\n  position: relative;\n  display: block;\n\n  border: 0;\n  text-transform: uppercase;\n  background-color: transparent;\n  cursor: pointer;\n\n  color: ",
        ";\n\n  color: ",
        ";\n\n  &:hover {\n    color: ",
        ";\n\n    color: ",
        ';\n  }\n\n  &::before,\n  &::after {\n    background-color: transparent;\n    content: "";\n    display: block;\n    position: absolute;\n    height: calc(50% - 0.4rem);\n    width: 100%;\n    border: 1px solid ',
        ";\n    border: 1px solid var(--smokeyWhite);\n    left: 0;\n  }\n\n  &::before {\n    border-bottom: none;\n    top: 0;\n  }\n\n  &::after {\n    border-top: none;\n    bottom: 0;\n  }\n\n  &:disabled {\n    cursor: not-allowed;\n  }\n\n  &:disabled:active {\n    pointer-events: none;\n  }\n\n  &:focus,\n  &:focus-visible {\n    outline-color: var(--blue);\n    outline-offset: 4px;\n    outline-width: 2px;\n    outline-style: solid;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        '\n  /* LABEL  */\n  display: block;\n  position: relative;\n  overflow: hidden;\n  margin: 0;\n\n  &:before {\n    content: "";\n    height: 100%;\n    display: block;\n    position: absolute;\n    width: 100%;\n    left: 0;\n    bottom: 0;\n\n    border: 1px solid ',
        ";\n    border: 1px solid var(--smokeyWhite);\n\n    background-color: ",
        ";\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        '\n  /* Hover Effect */\n  content: "";\n  display: block;\n  position: absolute;\n  height: 100%;\n  width: 120%;\n  top: 0;\n  left: -5%;\n  z-index: 1;\n  background-color: rgba(0, 0, 0, 0.7);\n  transform: translateX(-100%) skew(-10deg);\n  transition: transform 0.3s ease-out;\n\n  ',
        ":hover & {\n    transform: translateX(0) skew(-10deg);\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        '\n  /* Label Text */\n  font-family: Recursive, sans-serif;\n  position: relative;\n  display: block;\n  padding: 1.9rem 3rem;\n  background-color: transparent;\n  z-index: 1;\n  color: inherit;\n\n  opacity: 1;\n  transition: color 0.2s ease-in, opacity 0.2s ease-in;\n\n  &:after {\n    content: "";\n    display: block;\n    position: absolute;\n    height: 0.6rem;\n    width: 0.6rem;\n    right: 0;\n    bottom: 0;\n\n    background-color: ',
        ';\n    background-color: var(--white);\n\n    transition: background-color 0.2s ease-in;\n  }\n\n  &[data-disabled="true"] {\n    opacity: 0.5;\n  }\n\n  ',
        ":hover &:after {\n    background-color: ",
        ";\n    background-color: var(--softDark);\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var BaseButton = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-c38aa3a4-0"
})(_templateObject(), _styled_system_space__WEBPACK_IMPORTED_MODULE_1__/* .space */ .Dh, (0,_styled_system_space__WEBPACK_IMPORTED_MODULE_1__/* .space */ .Dh)({
    p: 2
}), function(param) {
    var _fontSize = param.fontSize, fontSize = _fontSize === void 0 ? "1.6rem" : _fontSize;
    return fontSize;
}, function(param) {
    var variant = param.variant;
    return variant === "outlined" ? design_system_Global_theme__WEBPACK_IMPORTED_MODULE_2__/* .theme.smokeyWhite */ .rS.smokeyWhite : design_system_Global_theme__WEBPACK_IMPORTED_MODULE_2__/* .theme.lightYellow */ .rS.lightYellow;
}, function(param) {
    var variant = param.variant;
    return variant === "outlined" ? "var(--smokeyWhite)" : "var(--lightYellow)";
}, function(param) {
    var variant = param.variant;
    return variant === "outlined" ? design_system_Global_theme__WEBPACK_IMPORTED_MODULE_2__/* .theme.white */ .rS.white : design_system_Global_theme__WEBPACK_IMPORTED_MODULE_2__/* .theme.yellow */ .rS.yellow;
}, function(param) {
    var variant = param.variant;
    return variant === "outlined" ? "var(--white)" : "var(--yellow)";
}, design_system_Global_theme__WEBPACK_IMPORTED_MODULE_2__/* .theme.smokeyWhite */ .rS.smokeyWhite);
var Label = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-c38aa3a4-1"
})(_templateObject1(), design_system_Global_theme__WEBPACK_IMPORTED_MODULE_2__/* .theme.smokeyWhite */ .rS.smokeyWhite, function(param) {
    var variant = param.variant;
    return variant === "outlined" ? "transparent" : design_system_Global_theme__WEBPACK_IMPORTED_MODULE_2__/* .theme.softDark */ .rS.softDark;
}, function(param) {
    var variant = param.variant;
    return variant === "outlined" ? "transparent" : "var(--softDark)";
});
var HoverEffect = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-c38aa3a4-2"
})(_templateObject2(), BaseButton);
var Text = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-c38aa3a4-3"
})(_templateObject3(), design_system_Global_theme__WEBPACK_IMPORTED_MODULE_2__/* .theme.white */ .rS.white, BaseButton, design_system_Global_theme__WEBPACK_IMPORTED_MODULE_2__/* .theme.softDark */ .rS.softDark);
var Button = function(_param) /*#__PURE__*/ {
    var _variant = _param.variant, variant = _variant === void 0 ? "primary" : _variant, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, children = _param.children, rest = _objectWithoutProperties(_param, [
        "variant",
        "disabled",
        "children"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BaseButton, _objectSpread({
        disabled: disabled,
        variant: variant
    }, rest, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Label, {
            variant: variant,
            children: [
                !disabled && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HoverEffect, {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Text, {
                    "data-disabled": disabled,
                    children: children
                })
            ]
        })
    }));
};



/***/ }),

/***/ 1880:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$0": function() { return /* binding */ Section; },
/* harmony export */   "M$": function() { return /* binding */ SectionHeader; },
/* harmony export */   "Hn": function() { return /* binding */ FullPage; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7379);
/* harmony import */ var _styled_system_space__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4460);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  min-height: 100vh;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var Section = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-27e30aba-0"
})(_templateObject(), (0,_styled_system_space__WEBPACK_IMPORTED_MODULE_0__/* .space */ .Dh)({
    my: 3,
    px: 2
}), _styled_system_space__WEBPACK_IMPORTED_MODULE_0__/* .space */ .Dh);
var SectionHeader = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].header.withConfig */ .ZP.header.withConfig({
    componentId: "sc-27e30aba-1"
})(_templateObject1(), (0,_styled_system_space__WEBPACK_IMPORTED_MODULE_0__/* .space */ .Dh)({
    pt: 4
}), _styled_system_space__WEBPACK_IMPORTED_MODULE_0__/* .space */ .Dh);
var FullPage = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(Section).withConfig({
    componentId: "sc-27e30aba-2"
})(_templateObject2());


/***/ }),

/***/ 4087:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ Stale; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7379);
/* harmony import */ var _styled_system_space__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4460);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  display: block;\n  width: 100%;\n  opacity: ",
        ";\n  transition: opacity 1s ease-in-out;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Stale = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2fa38f2b-0"
})(_templateObject(), _styled_system_space__WEBPACK_IMPORTED_MODULE_0__/* .space */ .Dh, function(param) {
    var _$stale = param.$stale, $stale = _$stale === void 0 ? false : _$stale;
    return $stale ? 0.3 : 1;
});


/***/ }),

/***/ 1588:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YM": function() { return /* binding */ head; },
/* harmony export */   "Gg": function() { return /* binding */ exists; },
/* harmony export */   "kC": function() { return /* binding */ capitalize; },
/* harmony export */   "iu": function() { return /* binding */ circular; },
/* harmony export */   "XT": function() { return /* binding */ circularSlice; }
/* harmony export */ });
/* unused harmony exports pipe, curry, curryRight, take, last, purify, split */
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
// Pipe
var pipe = function() {
    for(var _len1 = arguments.length, funcs = new Array(_len1), _key1 = 0; _key1 < _len1; _key1++){
        funcs[_key1] = arguments[_key1];
    }
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return funcs.reduce(function(val, func, i) {
            return i === 0 ? func.apply(void 0, _toConsumableArray(val)) : func(val);
        }, args);
    };
};
var curry = function(f) {
    return function(a) {
        return function() {
            for(var _len = arguments.length, b = new Array(_len), _key = 0; _key < _len; _key++){
                b[_key] = arguments[_key];
            }
            return f.apply(void 0, [
                a
            ].concat(_toConsumableArray(b)));
        };
    };
};
var curryRight = function(f) {
    return function() {
        for(var _len = arguments.length, b = new Array(_len), _key = 0; _key < _len; _key++){
            b[_key] = arguments[_key];
        }
        return function(a) {
            return f.apply(void 0, [
                a
            ].concat(_toConsumableArray(b)));
        };
    };
};
var take = function(n) {
    var m = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return function(array) {
        return array.slice(m, n + m);
    };
};
var head = function(param) {
    var _param = _slicedToArray(param, 1), head1 = _param[0];
    return head1;
};
var last = function(arr) {
    return head(arr.slice(-1));
};
var exists = function(val) {
    return val === (val !== null && val !== void 0 ? val : !val);
};
var purify = function(arr) {
    return arr.filter(exists);
};
var split = function(string, pattern) {
    return string.split(pattern);
};
var capitalize = function(string) {
    return "".concat(string.charAt(0).toUpperCase()).concat(string.slice(1));
};
function circular(index, step, limit) {
    return (limit + (index + step) % limit) % limit;
}
function circularSlice(arr, from, to) {
    var limit = arr.length;
    return Array.from({
        length: to - from
    }, function(_, index) {
        return arr[(from + index) % limit];
    });
}


/***/ }),

/***/ 9238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SE": function() { return /* binding */ yearStart; },
/* harmony export */   "D": function() { return /* binding */ yearEnd; },
/* harmony export */   "Y1": function() { return /* binding */ isoStringWithoutMs; }
/* harmony export */ });
/* unused harmony exports softTopScroll, onScrollThreshold, createClamp, clamp, trunc */
/* harmony import */ var functional__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1588);

// softly scroll to top
var softTopScroll = function() {
    var documentElement = document.documentElement, body = document.body;
    var distance = documentElement.scrollTop || body.scrollTop;
    var step = 8;
    if (distance > 0) {
        window.requestAnimationFrame(softTopScroll);
        window.scrollTo(0, distance - distance / step);
    }
    return null;
};
// toggles the key on threshold pass
function onScrollThreshold(setter) {
    var threshold = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100;
    if (window.scrollY > threshold) {
        return setter(true);
    }
    return setter(false);
}
// from today at midnight till january 1st at midnight
var yearStart = function() {
    var year = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new Date().getFullYear();
    var from = new Date("".concat(year, "-01-01"));
    from.setUTCHours(0, 0, 0, 0);
    return {
        from: from.toISOString()
    };
};
// a whole year span
var yearEnd = function(year) {
    var to = new Date("".concat(year, "-12-31"));
    to.setUTCHours(23, 59, 59, 999);
    var from = new Date("".concat(year, "-01-01"));
    from.setUTCHours(0, 0, 0, 0);
    return {
        from: from.toISOString(),
        to: to.toISOString()
    };
};
function createClamp(min, max) {
    return function(val) {
        return Math.min(Math.max(val, min), max);
    };
}
var clamp = function(val, min, max) {
    return createClamp(min, max)(val);
};
var isoStringWithoutMs = function(iso) {
    return (0,functional__WEBPACK_IMPORTED_MODULE_0__/* .head */ .YM)(iso.split("."));
};
var trunc = function(num) {
    if (Math.trunc) return Math.trunc(num);
    return num < 0 ? Math.ceil(num) : Math.floor(num);
};


/***/ }),

/***/ 8125:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ke": function() { return /* binding */ useFitbitHR; },
/* harmony export */   "HH": function() { return /* binding */ useFitbitActivityLog; }
/* harmony export */ });
/* unused harmony export useFitbitProfile */
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(821);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}




var profileFetcher = function() {
    return axios.get("/api/fitbit/profile").then(function(param) {
        var data = param.data;
        return data.user;
    });
};
var useFitbitProfile = function() {
    var fallbackData = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    return useSWR("fitbit/profile", profileFetcher, {
        shouldRetryOnError: false,
        fallbackData: fallbackData
    });
};
var heartRateFetcher = function(date, period) {
    return axios__WEBPACK_IMPORTED_MODULE_2___default().get("/api/fitbit/activities/heart/date/".concat(date, "/").concat(period)).then(function(param) {
        var data = param.data;
        return data;
    });
};
var activityLogFetcher = function() {
    var _ref = _asyncToGenerator(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(beforeDate) {
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return new Promise(function(resolve) {
                        return setTimeout(resolve, 750);
                    });
                case 2:
                    _ctx.next = 4;
                    return axios__WEBPACK_IMPORTED_MODULE_2___default().get("/api/fitbit/activities/list", {
                        params: {
                            beforeDate: beforeDate
                        },
                        paramsSerializer: function() {
                            var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                            return encodeURI(Object.entries(params).map(function(param) {
                                var _param = _slicedToArray(param, 2), key = _param[0], value = _param[1];
                                return "".concat(key, "=").concat(value);
                            }).join("&"));
                        }
                    }).then(function(param) {
                        var data = param.data;
                        return data;
                    });
                case 4:
                    return _ctx.abrupt("return", _ctx.sent);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function activityLogFetcher(beforeDate) {
        return _ref.apply(this, arguments);
    };
}();
var useFitbitHR = function(param, fallbackData) {
    var date = param.date, period = param.period, _revalidateOnMount = param.revalidateOnMount, revalidateOnMount = _revalidateOnMount === void 0 ? false : _revalidateOnMount;
    return (0,swr__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)([
        date,
        period
    ], function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return heartRateFetcher.apply(void 0, _toConsumableArray(args));
    }, {
        shouldRetryOnError: false,
        revalidateOnFocus: false,
        revalidateOnMount: revalidateOnMount,
        fallbackData: fallbackData
    });
};
var useFitbitActivityLog = function(beforeDate, initial) {
    var mounted = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        mounted.current = true;
    }, []);
    return (0,swr__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(beforeDate, activityLogFetcher, {
        shouldRetryOnError: false,
        revalidateOnFocus: false,
        fallbackData: mounted.current ? null : initial
    });
};


/***/ }),

/***/ 5673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ useLastNonNullableValue; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

var useLastNonNullableValue = function(value) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(value);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (value) {
            ref.current = value;
        }
    }, [
        value
    ]);
    return ref.current;
};


/***/ }),

/***/ 4785:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ useLoader; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var nprogress__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4865);
/* harmony import */ var nprogress__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(nprogress__WEBPACK_IMPORTED_MODULE_1__);


var createManager = function() {
    var current = 0;
    var subs = new Set();
    return {
        new: function _new() {
            var curr = current;
            current = current + 1;
            return Symbol(curr);
        },
        startLoader: function startLoader(sym) {
            if (subs.has(sym)) return;
            subs.add(sym);
            if (!nprogress__WEBPACK_IMPORTED_MODULE_1___default().isStarted()) return nprogress__WEBPACK_IMPORTED_MODULE_1___default().start();
            return;
        },
        endLoader: function endLoader(sym) {
            subs.delete(sym);
            if (nprogress__WEBPACK_IMPORTED_MODULE_1___default().isStarted()) {
                if (subs.size === 0) nprogress__WEBPACK_IMPORTED_MODULE_1___default().done();
                else nprogress__WEBPACK_IMPORTED_MODULE_1___default().inc();
            }
        }
    };
};
var manager = createManager();
var useLoader = function(data, error) {
    var symbol = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(manager.new());
    var stale = !error && !data;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (error) manager.endLoader(symbol.current);
    }, [
        error
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (stale) manager.startLoader(symbol.current);
        else manager.endLoader(symbol.current);
    }, [
        stale
    ]);
    return null;
};


/***/ })

}]);